<template>
  <div>
    <Jkfillgl />
  </div>
</template>

<script>
  // 获取接口地址
  import Jkfillgl from '../components/jkfill/jkfillgl.vue'

  export default {
    name: 'Jkfill',
    components: {
      Jkfillgl
    },
    data() {
      return {}
    },
    created: function() {},
    methods: {}
  }
</script>

<style scoped>
</style>
